import React from 'react'
import { Panel } from "reactflow";
import {
   FaLink,FaRegEnvelope 
  } from "react-icons/fa";
  
function About() {
  return (
    <Panel position="bottom-left" className='text-xs text-gray-400 flex gap-1'>
        <a href="https://ben-nine.vercel.app/" target="_blank" > A propos </a> |  Copyright 2024
    </Panel>
  )
}

export default About